<script lang="ts">
  import Close from '$icons/CloseAltIcon.svelte';
  import Edit from '$icons/EditIcon.svelte';
  import TickCircle from '$icons/TickCircleIcon.svelte';
  import { createEventDispatcher } from 'svelte';
  import { fly } from 'svelte/transition';

  export let label = '';

  let element: HTMLInputElement;

  let editMode = false;
  let editingLabel = label;
  let dispatch = createEventDispatcher();
</script>

{#key label}
  <div class="flex flex-row items-center gap-1">
    {#if !editMode}
      <span>
        {#if label}{label}{:else}&nbsp;{/if}
      </span>
      <span
        role="button"
        tabindex="0"
        in:fly|global
        class="pt-0.5 cursor-pointer"
        on:click={() => {
          editMode = true;
          element.focus();
        }}
        on:keydown
      >
        <Edit />
      </span>
    {/if}

    <input
      contenteditable="true"
      class="outline-none {editMode ? '' : 'opacity-0 pointer-events-none'}"
      bind:this={element}
      maxlength={20}
      bind:value={editingLabel}
      on:keydown={e => {
        if (e.key === 'Enter') {
          label = editingLabel;
          dispatch('labelChange', { newLabel: editingLabel });
          editMode = false;
        }
      }}
    />

    {#if editMode}
      <div
        in:fly|global
        class="text-garden-grey-300 bg-garden-grey-100 rounded h-5 w-12 flex flex-row justify-evenly text-center items-center"
      >
        <span
          role="button"
          tabindex="0"
          on:click={() => {
            editingLabel = label;
            editMode = false;
          }}
          on:keydown
          class="cursor-pointer"
        >
          <Close color={editingLabel == label ? 'currentColor' : '#102824'} />
        </span>
        |
        <span
          role="button"
          tabindex="0"
          class="cursor-pointer"
          on:keydown
          on:click={() => {
            label = editingLabel;
            dispatch('labelChange', { newLabel: editingLabel });
            editMode = false;
          }}
        >
          <TickCircle />
        </span>
      </div>
    {/if}
  </div>
{/key}
